export const SERVER_TIME_DIFF_UPDATE = "SERVER_TIME_DIFF_UPDATE";

export function serverTimeDiffUpdate(serverTimeDifference) {
  return { type: SERVER_TIME_DIFF_UPDATE, serverTimeDifference };
}
